/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Chat_Tool_Detail_FilesInputs */

const es_chat_tool_detail_files = /** @type {(inputs: Chat_Tool_Detail_FilesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} archivos`)
};

const en_chat_tool_detail_files = /** @type {(inputs: Chat_Tool_Detail_FilesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} files`)
};

/**
* | output |
* | --- |
* | "{count} files" |
*
* @param {Chat_Tool_Detail_FilesInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_tool_detail_files = /** @type {((inputs: Chat_Tool_Detail_FilesInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Detail_FilesInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_tool_detail_files(inputs)
	return en_chat_tool_detail_files(inputs)
});
export { chat_tool_detail_files as "chat.tool_detail.files" }